/* Créée par Incipit Studio — introduction avec une seconde de lecture finale. */
(() => {
  if (window.kaarzPreloaderInit) { window.kaarzPreloaderInit(); return; }
  const init = () => {
    document.querySelectorAll('[data-kp]').forEach(async el => {
      if (el.hidden || el._kpStarted) return;
      el._kpStarted = true;
      const abort = new AbortController(), signal = abort.signal;
      let frame, endTimer, start, finished = false, observers = [];
      const saved = new Map();
      const cleanup = () => {
        if (finished) return;
        finished = true;
        cancelAnimationFrame(frame); clearTimeout(endTimer); clearTimeout(el._kpSafety);
        abort.abort(); observers.forEach(o => o.disconnect());
        saved.forEach((value,node) => {node.inert = value;});
        document.documentElement.classList.remove('kp-lock'); el.hidden = true;
      };
      el._kpCleanup = cleanup;
      window.addEventListener('pagehide', cleanup, {signal});
      window.addEventListener('pageshow', e => {if(e.persisted)cleanup();}, {signal});
      document.addEventListener('shopify:section:unload', e => {if(e.target.contains(el))cleanup();}, {signal});
      // Bloquer le focus dans le site derrière l’introduction, puis restaurer son état.
      [...document.body.children].forEach(node => {
        if (node.contains(el) || ['SCRIPT','STYLE','LINK'].includes(node.tagName)) return;
        saved.set(node,node.inert); node.inert = true;
      });
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') cleanup();
        if (e.key === 'Tab') e.preventDefault();
      }, {signal});
      const logo = el.querySelector('.kp-logo');
      const target = document.querySelector('.kn-logo__black') || document.querySelector('.header__heading-logo');
      const align = () => {
        if (!target) return;
        const r = target.getBoundingClientRect();
        if (!r.width || !r.height) return;
        Object.assign(logo.style,{left:r.left+'px',top:r.top+'px',width:r.width+'px',height:r.height+'px',visibility:'visible'});
      };
      if (target) {
        const observer = new ResizeObserver(align); observer.observe(target);
        const header = target.closest('.shopify-section'); if(header)observer.observe(header);
        observers.push(observer);
        window.addEventListener('resize',align,{signal});
        window.addEventListener('load',align,{signal}); align();
      } else { cleanup(); return; } // Ne pas imposer un logo mal placé à un autre thème.
      const slides = [...el.querySelectorAll('.kp-slide')];
      const phrases = slides.map(s => Array.from(s.querySelector('.kp-reserve').textContent));
      const ready = [...el.querySelectorAll('img')].map(img => {img.src=img.dataset.src;return img.decode();});
      if(document.fonts)ready.push(document.fonts.load('20px Supply'));
      try {
        await Promise.race([Promise.all(ready),new Promise((_,reject)=>setTimeout(()=>reject(new Error('timeout')),1800))]);
      } catch (_) {cleanup();return;}
      if (finished) return;
      align();
      let current = -1, letters = -1;
      start = performance.now();
      // Dernière phrase complète à 5,5 s, lecture jusqu’à 6,5 s, puis sortie.
      endTimer = setTimeout(cleanup,7050);
      const tick = now => {
        if (finished) return;
        const elapsed = now-start;
        if(elapsed >= 7050){cleanup();return;}
        const index = Math.min(3,Math.floor(elapsed/1500));
        if(index !== current){
          current=index;letters=-1;
          slides.forEach((s,i)=>s.classList.toggle('is-active',i===index));
        }
        const local = elapsed-index*1500;
        const n = Math.min(phrases[index].length,Math.floor(local/1000*phrases[index].length));
        if(n!==letters){slides[index].querySelector('.kp-typed').textContent=phrases[index].slice(0,n).join('');letters=n;}
        // 1 s d’écriture, puis lecture ; fondu bref lors du changement de voiture.
        if(elapsed >= 6500)logo.style.opacity='0';
        if(elapsed >= 6650)el.classList.add('kp-exit');
        frame=requestAnimationFrame(tick);
      };
      frame=requestAnimationFrame(tick);
    });
  };
  window.kaarzPreloaderInit=init;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load', e => {
    // Les scripts inline ne sont pas exécutés par le rechargement de section Shopify.
    const el=e.target.querySelector('[data-kp]');
    if(!el || el.dataset.preview!=='true' || !window.Shopify?.designMode)return;
    el.hidden=false;document.documentElement.classList.add('kp-lock');
    el._kpSafety=setTimeout(()=>{el._kpCleanup?.();el.hidden=true;document.documentElement.classList.remove('kp-lock');},9000);
    init();
  });
})();
